import { render, staticRenderFns } from "./editQueue.vue?vue&type=template&id=9923360c&scoped=true&"
import script from "./editQueue.vue?vue&type=script&lang=js&"
export * from "./editQueue.vue?vue&type=script&lang=js&"
import style0 from "./editQueue.vue?vue&type=style&index=0&id=9923360c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923360c",
  null
  
)

export default component.exports